/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MentionSuggestionsResponse } from './MentionSuggestionsResponse';
import {
    MentionSuggestionsResponseFromJSON,
    MentionSuggestionsResponseFromJSONTyped,
    MentionSuggestionsResponseToJSON,
} from './MentionSuggestionsResponse';

/**
 * 
 * @export
 * @interface GetMentionSuggestions200Response
 */
export interface GetMentionSuggestions200Response {
    /**
     * 
     * @type {MentionSuggestionsResponse}
     * @memberof GetMentionSuggestions200Response
     */
    data?: MentionSuggestionsResponse;
}

/**
 * Check if a given object implements the GetMentionSuggestions200Response interface.
 */
export function instanceOfGetMentionSuggestions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMentionSuggestions200ResponseFromJSON(json: any): GetMentionSuggestions200Response {
    return GetMentionSuggestions200ResponseFromJSONTyped(json, false);
}

export function GetMentionSuggestions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMentionSuggestions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : MentionSuggestionsResponseFromJSON(json['data']),
    };
}

export function GetMentionSuggestions200ResponseToJSON(value?: GetMentionSuggestions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': MentionSuggestionsResponseToJSON(value.data),
    };
}

